// Deux portes d'entrée des comptes (spec § 3, décision du 24/10/2026) : les collaborateurs du client d'un côté,
// les partenaires de l'autre, toujours créés invités. Règles pures, partagées par les écrans et leurs tests.
import type { Sale } from "../types";

/**
 * « Mon organisation » ne s'ouvre qu'à un partenaire abonné rattaché à une organisation : un invité n'invite pas de
 * collègue et n'a pas de pipeline propre.
 */
export const seesOrganisation = (
  sale:
    | Pick<Sale, "partner" | "administrator" | "partner_offer" | "org_id">
    | undefined
    | null,
) =>
  !!sale?.partner &&
  !sale.administrator &&
  sale.partner_offer === "subscriber" &&
  sale.org_id != null;
